var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"s-canvas",on:{"click":_vm.createdCode}},[_c('canvas',{attrs:{"id":"s-canvas","width":_vm.contentWidth,"height":_vm.contentHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }